
import React, { useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "../CSS/resetPass.css";
import { BASE_API_URL } from "../constants";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token") || "", [params]);

  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const passwordsMatch = form.password && form.password === form.confirm;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passwordsMatch) return;

    setLoading(true);
    try {
      await axios.post(`${BASE_API_URL}/api/reset-password`, {
        token,
        password: form.password,
      });
      Swal.fire({
        title: "Password Reset Successful ",
        text: "You can now log in with your new password.",
        icon: "success",
        confirmButtonColor: "#ff8906",
      });
      setForm({ password: "", confirm: "" });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.response?.data?.detail || "Reset failed.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <h2 className="auth-title">Reset Password</h2>
        <p className="auth-subtitle">Set a new password for your account.</p>

        {!token ? (
          <div className="notice danger">Invalid link. No token found.</div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                id="password"
                placeholder="Enter new password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="confirm">Confirm Password</label>
              <input
                type="password"
                id="confirm"
                placeholder="Confirm new password"
                value={form.confirm}
                onChange={(e) => setForm({ ...form, confirm: e.target.value })}
                required
              />
              {!!form.confirm && !passwordsMatch && (
                <small className="hint danger">Passwords do not match.</small>
              )}
            </div>

            <button className="btn-primary" disabled={!passwordsMatch || loading}>
              {loading ? "Updating..." : "Reset Password"}
            </button>
          </form>
        )}

        <Link to="/login" className="link-back">
          &lt; Back to Login
        </Link>
      </div>
    </div>
  );
}
